import { useMenuLateral } from '@/context/MenuLateral';

import { usePendingExpansionRequestsCount } from '@/pages/Geo/hooks/usePendingExpansionRequestsCount';

import { Dot } from './styles';

export const PENDING_EXPANSION_REQUESTS_LABEL = 'Há pedidos de ampliação em análise';

interface Props {
  // As permissões do item do menu: a contagem só roda pra quem vê o item.
  permissions: string[];
}

/**
 * A bolinha ao lado de "Pedidos de ampliação" no menu: acende quando há
 * pedido em análise (ajuste pedido na apresentação de 25/09/2026). Só sinaliza
 * que existem — quantos e quais é na fila. A consulta só roda pra quem vê o
 * item (`shouldBeVisibleTo`, o mesmo crivo do `NavItemComponent`): o item
 * escondido é `display: none`, continua montado.
 */
const ExpansionRequestsIndicator = ({ permissions }: Props) => {
  const { shouldBeVisibleTo } = useMenuLateral();
  const { data: count } = usePendingExpansionRequestsCount({
    enabled: !!shouldBeVisibleTo(permissions),
  });

  if (!count) return null;

  return (
    <Dot
      role="status"
      aria-label={PENDING_EXPANSION_REQUESTS_LABEL}
      title={PENDING_EXPANSION_REQUESTS_LABEL}
    />
  );
};

export default ExpansionRequestsIndicator;
